import Users                        from 'scripts/defa/users/collection-users';
import UserController               from 'scripts/defa/users/controller-user-controller';
import User                         from 'scripts/defa/users/model-user';
import UserRouter                   from 'scripts/defa/users/router-user-router';
import UserContainer                from 'scripts/defa/users/view-user-container';
import UserCreateForm               from 'scripts/defa/users/view-user-create-form';
import UserForgotPasswordForm       from 'scripts/defa/users/view-user-forgot-password-form';
import UserLanguageForm             from 'scripts/defa/users/view-user-language-form';
import UserLoginCreateDualContainer from 'scripts/defa/users/view-user-login-create-dual-container';
import UserLoginForm                from 'scripts/defa/users/view-user-login-form';
import UserNewAccountView           from 'scripts/defa/users/view-user-new-account-view';
import UserNewPasswordForm          from 'scripts/defa/users/view-user-new-password-form';
import UserPasswordForm             from 'scripts/defa/users/view-user-password-form';
import UserSettingsPanel            from 'scripts/defa/users/view-user-settings-panel';
import UserThankYouView             from 'scripts/defa/users/view-user-thank-you-view';
import UserVerifyEmailForm          from 'scripts/defa/users/view-user-verify-email-form';
import Module                       from 'scripts/module';

const UserModule = new Module( 'UserModule', {
	models     : {
		User
	},
	collections: {
		Users
	},
	controllers: {
		UserController
	},
	routers    : {
		UserRouter
	},
	views      : {
		UserNewAccountView,
		UserContainer,
		UserCreateForm,
		UserForgotPasswordForm,
		UserLanguageForm,
		UserLoginCreateDualContainer,
		UserVerifyEmailForm,
		UserThankYouView,
		UserSettingsPanel,
		UserPasswordForm,
		UserNewPasswordForm,
		UserLoginForm,
	}
} );

export default UserModule;